export default __webpack_public_path__ + "pgnv-assets/b2f4694749f5b78e0f82af2ae01c22a4.png";